import React from "react";
import { motion } from "framer-motion";
import { LucideIcon } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";
interface EntityListItemProps {
  entity: any;
  variant: "shop" | "tavern" | "loot";
  icon: LucideIcon;
  isSelected: boolean;
  isSelectionMode: boolean;
  onSelect: () => void;
  onClick: () => void;
}
const EntityListItem: React.FC<EntityListItemProps> = ({
  entity,
  variant,
  icon: Icon,
  isSelected,
  isSelectionMode,
  onSelect,
  onClick
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (isSelectionMode) {
      e.preventDefault();
      onSelect();
    } else {
      onClick();
    }
  };
  const handleCheckboxClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onSelect();
  };
  const getEntityName = () => {
    switch (variant) {
      case "shop":
        return entity.outputData.shopName;
      case "tavern":
        return entity.outputData.tavernName;
      case "loot":
        return entity.outputData.lootName;
      default:
        return "";
    }
  };
  const getEntityDetails = () => {
    switch (variant) {
      case "shop":
        return `${entity.outputData.inventory.length} items`;
      case "tavern":
        return `${entity.outputData.amenities.length} amenities`;
      case "loot":
        return `${entity.outputData.lootItems.length} items`;
      default:
        return "";
    }
  };
  return <motion.div layout initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className={cn("relative p-4 rounded-lg border transition-all cursor-pointer hover:scale-[1.01]", "bg-slate-800/50", "border-slate-700", ...(isSelected ? ["bg-sky-500/10", "border-sky-500"] : []))} onClick={handleClick} data-sentry-element="unknown" data-sentry-component="EntityListItem" data-sentry-source-file="index.tsx">
            <div className="flex items-center gap-4">
                {isSelectionMode && <div onClick={handleCheckboxClick}>
                        <Checkbox checked={isSelected} />
                    </div>}
                <Icon className={cn("w-5 h-5", "text-slate-400")} data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
                <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                        <h3 className={cn("font-medium truncate", "text-sky-200")}>
                            {getEntityName()}
                        </h3>
                        <span className="px-2 py-1 text-xs rounded-full bg-slate-900/50 border border-slate-700 text-sky-400">
                            {getEntityDetails()}
                        </span>
                    </div>
                    <p className={cn("text-sm truncate", "text-slate-400")}>
                        Created on{" "}
                        {new Date(entity.createdAt).toLocaleDateString()}
                    </p>
                </div>
            </div>
        </motion.div>;
};
export default EntityListItem;